import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import React3 from 'react-three-renderer';

import {Dimmer, Header, Loader} from 'semantic-ui-react';

import {animationFrame} from '../actions';

import {preloadModels} from './Model';
import {SceneNoiseForm, SceneSphereForm} from './Forms';

import {computePlanet, updateElevation, updateRadius} from '../actions/planet';
import Planet, {PlanetResources} from './planet';

import './index.css';

class Scene extends PureComponent {

    constructor(props, context) {
        super(props, context);
        const {
            match: {
                params: {
                    seed
                }
            }
        } = props;
        this.timestamp = 0;
        this.state = {
            ready: false,
            seed: this.formatSeed(seed || Date.now()),
            params: {
                lacunarity: 2.0,
                npoints: 256,
                octaves: 1,
                persistence: 0.5
            }
        };
    }

    formatSeed = timestamp => timestamp % (2 ** 32 - 1)

    onAnimate = () => {
        const time = Date.now(),
            delta = (time - this.timestamp) / 1000;
        this
            .props
            .animationFrame(delta);
        this.timestamp = time;
    }

    onRefreshSeed = () => {
        const {params} = this.state,
            timestamp = Date.now(),
            seed = this.formatSeed(timestamp);
        this.setState({seed});
        this
            .props
            .computePlanet(seed, params);
    }

    onSubmit = () => {
        const {seed, params} = this.state;
        this
            .props
            .computePlanet(seed, params);
    }

    onUpdateParam = (name, value) => this.setState({
        params: {
            ...this.state.params,
            [name]: value
        }
    })

    onUpdateSeed = (timestamp) => this.setState({seed: this.formatSeed(timestamp)})

    componentDidMount() {
        const {params, seed} = this.state;
        this
            .props
            .computePlanet(seed, params);
        preloadModels([
            "PUSHILIN_stone",
            "SpruceTree",
            "OakTree",
            "BloodwoodTree",
            "DatePalmTree",
            "SM_Cabana_02",
            "PUSHILIN_grass"
        ]).then(() => this.setState({ready: true}));
    }

    render() {
        const {camera, planet} = this.props, {params, ready, seed} = this.state;
        return <div className="Scene">
            <SceneRenderer
                key="renderer"
                camera={camera}
                loading={!ready || planet.loading}
                planet={planet}
                onAnimate={this.onAnimate}/>
            <SceneSphereForm
                key="secondary-form"
                elevation={planet.elevation}
                onUpdateElevation={this.props.updateElevation}
                onUpdateRadius={this.props.updateRadius}
                radius={planet.radius}/>
            <Header as="h3">Noise and Voronoi Settings</Header>
            <SceneNoiseForm
                key="primary-form"
                loading={planet.loading}
                onRefreshSeed={this.onRefreshSeed}
                onSubmit={this.onSubmit}
                onUpdateParam={this.onUpdateParam}
                onUpdateSeed={this.onUpdateSeed}
                params={params}
                seed={seed}/>
        </div>;
    }
}

export default connect(({
    scenePlanet: {
        camera,
        planet
    }
}) => ({camera, planet}), {animationFrame, computePlanet, updateElevation, updateRadius})(Scene);

export class SceneRenderer extends PureComponent {
    render() {
        const {
            camera,
            loading,
            onAnimate,
            planet: {
                error,
                ...planet
            }
        } = this.props;
        return <div className="SceneRenderer">
            {
                error
                    ? null
                    : <React3
                            antialias={true}
                            mainCamera="camera"
                            width={700}
                            height={700}
                            onAnimate={onAnimate}
                            clearColor={0xffffff}
                            precision="lowp">
                            <PlanetResources key="planet-resources"/>
                            <scene key="scene">
                                <perspectiveCamera
                                    key="camera"
                                    name="camera"
                                    aspect={1}
                                    far={camera.far}
                                    fov={camera.fov}
                                    lookAt={planet.center}
                                    near={camera.near}
                                    position={camera.position}/>
                                <directionalLight
                                    key="light"
                                    color={0xffffff}
                                    intensity={0.67}
                                    lookAt={planet.position}
                                    position={camera.position}/>
                                <Planet key="planet" {...planet}/>
                            </scene>
                        </React3>
            }
            <Dimmer key="loader" active={loading} inverted={true}>
                <Loader inverted={true}/>
            </Dimmer>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/index.js